import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-slate-800 text-white py-24 px-4 sm:px-6 lg:px-8" data-id="element-56">
      <div className="max-w-3xl mx-auto" data-id="element-57">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-58">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-59">
          {/* FAQ 1 */}
          <div className="bg-slate-900 rounded-2xl border border-slate-700 overflow-hidden transition-all duration-200" data-id="element-60">
            <button onClick={() => toggleFaq(0)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500" aria-expanded={openIndex === 0} data-id="element-61">
              <span className="font-bold text-lg pr-4" data-id="element-62">
                ¿Necesito un banco específico?
              </span>
              <ChevronDownIcon className={`w-5 h-5 text-amber-500 transition-transform duration-200 flex-shrink-0 ${openIndex === 0 ? 'rotate-180' : ''}`} data-id="element-63" />
            </button>
            <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 0 ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-64">
              <p className="text-slate-300" data-id="element-65">
                No, puedes usar cualquier banco o billetera virtual de Latam.
              </p>
            </div>
          </div>

          {/* FAQ 2 */}
          <div className="bg-slate-900 rounded-2xl border border-slate-700 overflow-hidden transition-all duration-200" data-id="element-66">
            <button onClick={() => toggleFaq(1)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500" aria-expanded={openIndex === 1} data-id="element-67">
              <span className="font-bold text-lg pr-4" data-id="element-68">
                ¿Tengo que dejar de salir a comer?
              </span>
              <ChevronDownIcon className={`w-5 h-5 text-amber-500 transition-transform duration-200 flex-shrink-0 ${openIndex === 1 ? 'rotate-180' : ''}`} data-id="element-69" />
            </button>
            <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 1 ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-70">
              <p className="text-slate-300" data-id="element-71">
                No, el sistema incluye un sobre de "Disfrute Consciente" para
                que gastes sin culpa.
              </p>
            </div>
          </div>

          {/* FAQ 3 */}
          <div className="bg-slate-900 rounded-2xl border border-slate-700 overflow-hidden transition-all duration-200" data-id="element-72">
            <button onClick={() => toggleFaq(2)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500" aria-expanded={openIndex === 2} data-id="element-73">
              <span className="font-bold text-lg pr-4" data-id="element-74">
                ¿Es difícil de aprender?
              </span>
              <ChevronDownIcon className={`w-5 h-5 text-amber-500 transition-transform duration-200 flex-shrink-0 ${openIndex === 2 ? 'rotate-180' : ''}`} data-id="element-75" />
            </button>
            <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 2 ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-76">
              <p className="text-slate-300" data-id="element-77">
                El manual es corto y directo. Se lee en una hora y se aplica en
                30 minutos.
              </p>
            </div>
          </div>

          {/* FAQ 4 */}
          <div className="bg-slate-900 rounded-2xl border border-slate-700 overflow-hidden transition-all duration-200" data-id="element-78">
            <button onClick={() => toggleFaq(3)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500" aria-expanded={openIndex === 3} data-id="element-79">
              <span className="font-bold text-lg pr-4" data-id="element-80">
                ¿Sirve si tengo deudas?
              </span>
              <ChevronDownIcon className={`w-5 h-5 text-amber-500 transition-transform duration-200 flex-shrink-0 ${openIndex === 3 ? 'rotate-180' : ''}`} data-id="element-81" />
            </button>
            <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 3 ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-82">
              <p className="text-slate-300" data-id="element-83">
                Sí, es la mejor forma de organizar un plan de pagos real sin
                quedar en cero.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}